import React from 'react'
import GlobalStyle from '../styles/global'
import SEO from './SEO'

const Layout = () => (
  <>
    <SEO />
    <GlobalStyle />
  </>
)

export default Layout
